import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getMoqs } from '@/api/moqs';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      sort: 'id,DESC',
      filter: {
        enabled: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await getMoqs(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  getDateRangeColor(data) {
    if (data.startDate && data.endDate) {
      const startDate = this.$moment(data.startDate);
      const endDate = this.$moment(data.endDate);
      const now = this.$moment();
      // check if not yet started
      if (now > endDate) {
        return 'danger';
      } else if (now >= startDate && now <= endDate) {
        return 'success';
      } else if (startDate > now) {
        return 'primary';
      }
    }
    return 'info';
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
};
default_1 = __decorate([Component({
  name: 'MoqList',
  components: {
    Pagination,
    Enabled
  }
})], default_1);
export default default_1;